import { combineReducers } from 'redux'
import ArticlesAllReducer from './articles.all.reducer'
import ArticlesItemReducer from './articles.item.reducer'

const ArticlesReducer = combineReducers({
  all: ArticlesAllReducer,
  item: ArticlesItemReducer,
})

export default ArticlesReducer